import genericStyles from "../../Styles/genericStyles.module.css";
import { TablesIds } from "../../Utils/Constants";
import { ETableEditAction } from "../../Utils/Enums";
import { endpoints } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
export default function AlertsTable() {
  const alertsColumns = [
    {
      label: Vocabulary.userName,
      name: "name",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.property,
      name: "property",
      options: {
        sort: false,
        customBodyRender: (property: any) => {
          return `${property ? Vocabulary[property] : property}`;
        },
      },
    },
    {
      label: Vocabulary.rule,
      name: "rule",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.threshold,
      name: "threshold",
      options: {
        sort: false,
      },
    },
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <MUIDataTableCustomStyle
        buttons={[]}
        onEditAction={ETableEditAction.MODAL}
        title={Vocabulary.alerts}
        id={TablesIds.logs}
        hideAddButton={true}
        columns={alertsColumns}
        CRUDEndPoint={endpoints.alert.main}
        hideEditButton={true}
      />
    </div>
  );
}
